import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import Container from 'components/Container';
import history from 'routing/history';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import useBodyBackgroundColor from 'hooks/useBodyBackgroundColor';
import {
  fetchContracts,
  fetchLastCancelledContract
} from 'products/nomad_insurance/state/contract';
import {
  fetchPlanholderInfo,
  dismissNotification
} from 'products/nomad_insurance/state/planholder';
import Claims from './Claims';
import Notification from './components/Notification';
import ReferralPill from './components/ReferralPill';

import { NOTIFICATIONS, NOTIFICATION_TEXTS } from './notifications';

const Profile = () => {
  const dispatch = useDispatch();
  const [unseenNotifications, setUnseenNotifications] = useState([]);
  const { isAuthenticated } = useSelector((state) => state.app.user);
  const { isInitInProgress } = useSelector((state) => state.app);
  const { planholder } = useSelector((state) => state.nomadInsurance.planholder);
  const notifications = planholder?.notifications;
  if (isAuthenticated && !isInitInProgress && !planholder?.hasCompletedProfile) {
    history.push('/nomad-insurance/registration');
  }
  const theme = useTheme();
  useBodyBackgroundColor(theme.colors.white);
  const basePath = '/nomad-insurance';

  const { isLoading: isContractLoading, allActiveContracts } = useSelector(
    (state) => state.nomadInsurance.contract
  );

  const { isLoading } = useSelector((state) => state.nomadInsurance.profile.insurance);

  useEffect(() => {
    dispatch(fetchPlanholderInfo());
    dispatch(fetchContracts());
    dispatch(fetchLastCancelledContract());
  }, [dispatch]);

  useEffect(() => {
    setUnseenNotifications(
      (notifications || []).map((notification) => ({
        ...NOTIFICATIONS[notification.name],
        ...notification
      }))
    );
  }, [notifications]);

  const hideNotification = (notificationID) => {
    setUnseenNotifications(
      unseenNotifications.filter((x) => x.notificationID !== notificationID)
    );
  };

  // check for all contracts in order to avoid rendering the non-loading return
  // once before showing loading screen -> avoids running useEffects in children twice
  // allActiveContracts should be null before it's fetched, if no contracts it will be an
  // empty array but truthy
  if (!allActiveContracts || isContractLoading || isLoading) {
    return <Container bg="turquoise" variant="dark" isLoading />;
  }

  return (
    <>
      {unseenNotifications &&
        unseenNotifications.map((notification) => (
          <Notification
            key={notification.notificationID}
            type={notification.type}
            name={notification.name}
            imageSrc={notification.imageSrc}
            imageAlt={notification.imageAlt}
            getButton={() => {
              if (!notification.button) return null;
              return notification.button(
                NOTIFICATION_TEXTS[notification.name].buttonText,
                () => {
                  dispatch(dismissNotification(notification.notificationID));
                  hideNotification(notification.notificationID);
                  if (notification.onButtonClick) notification.onButtonClick();
                }
              );
            }}
            onClose={() => {
              dispatch(dismissNotification(notification.notificationID));
              hideNotification(notification.notificationID);
            }}
          />
        ))}
      <ReferralPill />
      <Switch>
        <Route exact path={`${basePath}/profile/claims`} component={Claims} />
      </Switch>
    </>
  );
};

export default Profile;
